// node_modules
import axios from "axios";
// Helpers
import { ToastHelperSingleton } from "Helpers";
// Enums
import { ToastTypeEnum } from "Enums";

export class AxiosHelper {
    public getServerBaseURL(): string {
        return "https://api.findest.com" || "";
    }

    public setCommonHeaderConfigDefaults(commonHeaderName: string, commonHeaderValue: string): void {
        axios.defaults.headers.common[commonHeaderName] = commonHeaderValue;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public displayAxiosError(error: any, defaultErrorMessage = "Something went wrong."): void {
        let errorMessage = defaultErrorMessage;
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.response && error.response.message) {
            errorMessage = error.response.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        // show error message
        ToastHelperSingleton
            .showToast(ToastTypeEnum.Error, errorMessage);
    }
}

export const AxiosHelperSingleton = new AxiosHelper();
